import {
  ActionType,
  DatePickerField,
  BooleanField,
  AutoTextField,
  ButtonGroupField,
  SelectField,
} from '../../../components/AutoForm/AutoFieldNew';
import {dateFieldValueType} from '../../../components/AutoForm/AutoFormNew';
import {
  TaskRegardingEntityEnum,
  TaskUrgencyEnum,
} from '../../../schema-types/globalTypes';

const tasksFieldsOld = {
  definitions: {
    deadline: {
      id: 'deadline',
      label: 'Deadline',
      action: {
        type: 'datepicker',
        format: 'DD MMMM YYYY',
      },
      initialValue: null,
    },
    urgency: {
      initialValue: false,
    },
    urgencyReason: {
      initialValue: '',
    },
    notes: {
      id: 'notes',
      label: 'Notes:',
      action: {
        type: 'note',
      },
    },
  },
};
export default tasksFieldsOld;

export const taskContactField: ButtonGroupField = {
  id: 'contact',
  label: 'Which contact is this task about?',
  type: ActionType.buttonGroup,
  options: [],
};
export const taskRegardingIdField: SelectField<TaskRegardingEntityEnum> = {
  id: 'regarding',
  label: 'Regarding',
  type: ActionType.select,
  options: [],
};
export const taskEntityOptionField: ButtonGroupField<TaskRegardingEntityEnum> = {
  id: 'taskEntityOption',
  label: 'DUMMY FIELD',
  type: ActionType.buttonGroup,
  options: [],
};
export const taskSelectedEntityField: ButtonGroupField<TaskRegardingEntityEnum> = {
  id: 'selectedEntityType',
  label: 'What is this referring to?',
  type: ActionType.buttonGroup,
  options: [],
};
export const taskDeadlineField: DatePickerField = {
  id: 'deadline',
  label: 'Deadline',
  type: ActionType.datepicker,
  helper: 'When is this due? Dates cannot be in the past',
};

export const taskUrgencyField: BooleanField<TaskUrgencyEnum> = {
  id: 'urgency',
  label: 'Urgency',
  type: ActionType.boolean,
  yesValue: TaskUrgencyEnum.URGENT,
  noValue: TaskUrgencyEnum.NORMAL,
};

export const taskUrgencyReasonField: AutoTextField = {
  id: 'urgencyReason',
  label: 'Urgency',
  type: ActionType.text,
};

export const taskNotesField: AutoTextField = {
  id: 'notes',
  label: 'Task description',
  type: ActionType.text,
  multiline: true,
  minRows: 10,
};

export const taskFields = [
  taskDeadlineField,
  taskUrgencyField,
  taskUrgencyReasonField,
  taskNotesField,
];

export type taskValues = {
  taskId?: string;
  deadline: dateFieldValueType;
  urgency: TaskUrgencyEnum;
  urgencyReason?: string;
  notes: string;
  subgroupId: string;
  taskEntityOption: TaskRegardingEntityEnum;
  selectedEntityType: TaskRegardingEntityEnum;
  regarding?: string;
  contact?: string;
  openAccordionGroup?: string;
  selectedEntityTypeDetails?: string;
};
